<template>
  <div class="detail flex flex-col">
    <el-row>
      <el-input
        v-model="query.keyword"
        size="small"
        class="w-200px"
        :placeholder="$t('attributeCodeOrName')"
        @keyup.enter.native="searchList"
        clearable
      />
      <el-input
        v-model="query.className"
        size="small"
        class="w-200px ml-10px"
        :placeholder="$t('entityName')"
        @keyup.enter.native="searchList"
        clearable
        v-if="type === 'entity'"
      />
      <el-button class="ml-10px" size="small" type="primary" @click="searchList">{{
        $t('search')
      }}</el-button>
      <el-button
        class="r"
        :disabled="multiple"
        size="small"
        type="primary"
        @click="add"
        v-if="!single"
        >{{ $t('addTo') }}</el-button
      >
    </el-row>
    <el-row class="flex-1 mt-20px h-320px">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          v-if="!single"
        ></el-table-column>
        <el-table-column
          prop="className"
          :label="$t('entityName')"
          show-overflow-tooltip
          v-if="type === 'entity'"
        ></el-table-column>
        <el-table-column
          prop="cateName"
          :label="$t('entityType')"
          show-overflow-tooltip
          v-else
        ></el-table-column>
        <el-table-column
          prop="classCode"
          :label="$t('Class') + $t('coding')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="code" :label="$t('coding')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" :label="$t('name')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" :label="$t('operate')" width="150" v-if="single">
          <template v-slot="scope">
            <el-button size="mini" @click="singleAdd(scope.row)">{{ $t('confirm') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        class="mt-20px"
        background
        @size-change="searchList()"
        @current-change="getList()"
        :current-page.sync="query.pageNum"
        :page-sizes="$pageSizeAll"
        :page-size.sync="query.pageSize"
        layout="->, total, sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import StdClassAttributeService from '@/services/bsApi/StdClassAttributeService'
import EntityTypeService from '@/services/EntityTypeService'

export default {
  name: 'assetQuery',
  props: ['single', 'standardId', 'type'],
  data() {
    return {
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 15,
        keyword: '',
        className: '',
      },
      dataList: [],
      selection: [],
      multiple: true,
      loading: false,
    }
  },
  created() {
    this.searchList()
  },
  methods: {
    searchList() {
      this.query.pageNum = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      // 实体管理
      if (this.type === 'entity') {
        const parameter = {
          standard_id: this.standardId,
          is_primary: true,
          keyword: this.query.keyword,
          pageno: this.query.pageNum,
          pagesize: this.query.pageSize,
          qry_class_name: this.query.className,
        }
        const res = await StdClassAttributeService.list(parameter)
        if (res && res.code === 0 && res.data) {
          this.dataList = res.data
          this.total = res.page.recordCount
        }
      } else if (this.type === 'entityType') {
        // 实体类型
        const res = await EntityTypeService.getEntityTypeAttributeList({
          StandardId: this.standardId,
          IsPrimary: true,
          filter: this.query.keyword,
          SkipCount: (this.query.pageNum - 1) * this.query.pageSize,
          MaxResultCount: this.query.pageSize,
        })
        if (res && res.code === 0 && res.data) {
          this.dataList = res.data
          this.total = res.totalCount
        }
      }
      this.loading = false
    },
    // 单个
    singleAdd(row) {
      this.$emit('selectReferenceClassAttributeId', row)
    },
    // 多个
    add() {
      this.$emit('selectReferenceClassAttributeId', this.selection)
    },
    selectionChange(val) {
      this.selection = val
      this.multiple = !val.length
    },
  },
}
</script>
<style lang="scss" scoped>

.detail {
  height: 500px;
  /deep/.el-table__body-wrapper {
    height: 90% !important;
  }
}

</style>
